import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _ROUTE_BREADCRUMBS;

/**
 * Routes constants for the application
 * Centralizes all route paths to avoid hardcoding and improve maintainability
 */
export var ROUTES = {
  // Main routes
  HOME: '/home',
  EXPLORE: '/explore',
  FAQ: '/faq',
  CONTACT_US: '/contact-us',
  // Category routes
  CATEGORY: {
    BASE: '/category',
    DETAIL: function DETAIL(id) {
      return "/explore/category/".concat(id);
    }
  }
}; // Header menu items using the routes constants

export var HEADER_ITEMS = [{
  key: 'explore',
  label: 'digibrickLibrary',
  route: ROUTES.EXPLORE
}, {
  key: 'faq',
  label: 'FAQ',
  route: ROUTES.FAQ
}, {
  key: 'contact-us',
  label: 'connectWithUs',
  route: ROUTES.CONTACT_US
}]; // Default selected key for the menu

export var DEFAULT_SELECTED_KEY_MENU = HEADER_ITEMS[0].key; // Breadcrumb configuration for each route

// Default home breadcrumb that appears in all breadcrumb paths
export var HOME_BREADCRUMB = {
  label: 'home',
  route: ROUTES.HOME
}; // Breadcrumb configurations for main routes

export var ROUTE_BREADCRUMBS = (_ROUTE_BREADCRUMBS = {}, _defineProperty(_ROUTE_BREADCRUMBS, ROUTES.HOME, [HOME_BREADCRUMB]), _defineProperty(_ROUTE_BREADCRUMBS, ROUTES.EXPLORE, [HOME_BREADCRUMB, {
  label: 'explore',
  route: ROUTES.EXPLORE
}]), _defineProperty(_ROUTE_BREADCRUMBS, ROUTES.FAQ, [HOME_BREADCRUMB, {
  label: 'FAQ',
  route: ROUTES.FAQ
}]), _defineProperty(_ROUTE_BREADCRUMBS, ROUTES.CONTACT_US, [HOME_BREADCRUMB, {
  label: 'connectWithUs',
  route: ROUTES.CONTACT_US
}]), _ROUTE_BREADCRUMBS);
/**
 * Get breadcrumb items for a given path
 * @param path Current route path
 * @param categories Optional categories data for dynamic category breadcrumbs
 * @returns Array of breadcrumb items
 */

export var getBreadcrumbsForPath = function getBreadcrumbsForPath(path, categories) {
  // First check if we have a direct match in our predefined breadcrumbs
  if (ROUTE_BREADCRUMBS[path]) {
    return ROUTE_BREADCRUMBS[path];
  } // Check for category paths


  if (path.includes(ROUTES.CATEGORY.BASE)) {
    var breadcrumbs = _toConsumableArray(ROUTE_BREADCRUMBS[ROUTES.EXPLORE]);

    var match = path.match(/\/category\/([^/?]+)/);

    if (match && match[1]) {
      var categoryId = match[1];
      var category = categories === null || categories === void 0 ? void 0 : categories.find(function (cat) {
        return cat.id.toString() === categoryId;
      });
      breadcrumbs.push({
        label: category ? category.key : categoryId,
        route: ROUTES.CATEGORY.DETAIL(categoryId)
      });
      return breadcrumbs;
    }
  } // Handle other dynamic paths that start with a main route


  for (var _i = 0, _Object$entries = Object.entries(ROUTE_BREADCRUMBS); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        route = _Object$entries$_i[0],
        crumbs = _Object$entries$_i[1];

    if (path.startsWith("".concat(route, "/")) && route !== ROUTES.HOME) {
      var _ret = function () {
        var breadcrumbs = _toConsumableArray(crumbs);

        var segments = path.split('/').filter(function (segment) {
          return segment;
        });
        var baseRoute = route.split('/').filter(function (s) {
          return s;
        })[0];
        var baseRouteIndex = segments.findIndex(function (s) {
          return s === baseRoute;
        });
        var additionalBreadcrumbs = segments.slice(baseRouteIndex + 1).reduce(function (acc, segment, index) {
          var segmentPath = '/' + segments.slice(0, baseRouteIndex + 2 + index).join('/');
          acc.push({
            label: segment,
            route: segmentPath
          });
          return acc;
        }, []);
        breadcrumbs.push.apply(breadcrumbs, _toConsumableArray(additionalBreadcrumbs));
        return {
          v: breadcrumbs
        };
      }();

      if (typeof _ret === "object") return _ret.v;
    }
  }

  return [HOME_BREADCRUMB];
};